import React from 'react';
import { Avatar } from '@mui/material';
import { Image } from 'react-bootstrap';
import QuillViewer from '../helper/QuillViewer';
import { formatMessageTime } from '../../helpers/date/messages';

const defaultProfile =
  'https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg';

const MessageText = ({ message, isFromReceived, ismediaText }) => {
  return (
    <>
      <li className={`${isFromReceived ? 'sentmsg' : 'receivemsg'} mb-0 `}>
        {isFromReceived && !ismediaText && (
          <div className='imgchat'>
            <Avatar
              src={message.user?.picture}
              style={{ width: '39px', height: '39px', marginLeft: '10px' }}
              className=' img-fluid'
              alt='avtar'
            >
              <img src={defaultProfile} style={{ width: '50px', height: '50px' }} alt='profile' />
            </Avatar>
          </div>
        )}
        <div
          className={`textchat ${!isFromReceived && 'bg-pink'} ${
            isFromReceived && ismediaText ? 'received-mediachat' : ''
          }`}
          style={{
            borderRadius: `${isFromReceived ? '8px 16px 16px 16px' : '16px 16px 8px 16px'}`,
          }}
        >
          <div className='headingchat '>
            <div className='videoattached position-relative  overflow-y-hidden'>
              <QuillViewer
                className={`message-items overflow-y-hidden py-0 ${
                  !isFromReceived && 'send-message'
                }`}
                id={`message-item-editor-${message.id}`}
                placeholder=''
                value={message.text}
                readOnly={true}
              />
              {!isFromReceived && (
                <span className='dateinfo position-absolute bottom-0 right-0'>
                  <Image
                    src={`https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/${
                      message.is_read ? `bi_check-all_white` : 'check_white'
                    }.svg`}
                    alt={`${message.is_read ? 'check icon' : 'check ico'}`}
                  />
                </span>
              )}
            </div>
          </div>
        </div>
      </li>
      {
        <div
          className={`dateinfo d-flex ${
            isFromReceived ? 'justify-content-start ml-4' : 'justify-content-end'
          } mb-3 mr-5per`}
        >
          {' '}
          {formatMessageTime(message.created_at)}
        </div>
      }
    </>
  );
};

export default MessageText;
